const config = () => ({
  dataPrivacyUrl:
    '/services/datenschutz-das-wichtigste-zum-datenschutz-in-kuerze-id8334786.html',
  dataPrivacyUrl___romandie:
    '/fr/services/protection-des-donnees-l-essentiel-en-bref-sur-la-protection-des-donnees-id16472333.html',
})

export type configType = ReturnType<typeof config>
export default config
